// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.zerion.wallet",
    name: "Zerion",
    homepage: "https://zerion.io/",
    image_id: "73f6f52f-7862-49e7-bb85-ba93ab72cc00",
    app: {
        browser: "https://app.zerion.io",
        ios: "https://apps.apple.com/app/id1456732565",
        android: "https://play.google.com/store/apps/details?id=io.zerion.android&hl=en&gl=US",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/zerion-wallet-for-web3-nf/klghhnkeealcohjjanjjdaeeggmfmlpl",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "io.zerion.wallet",
    mobile: {
        native: "zerion://",
        universal: "https://wallet.zerion.io/wc",
    },
    desktop: {
        native: "zerion://",
        universal: "https://wallet.zerion.io",
    },
};
//# sourceMappingURL=index.js.map